import React, { useState } from 'react';
import { Box } from '@mui/material';
import axiosInstance from '../../../../helpers/axios';
import aadhaarImage from '../../../../assets/images/aadhar_image.png'
import panImage from '../../../../assets/images/pan-image.png'
import InputFileUpload from './InputFileUpload';
import OCRLoadingModal from './OCRLoadingModal';

const OCRFileUpload = ({ onOCRSuccess, onOCRError, onOCRStart }) => {
  // State management similar to your target format
  const [ocrFormData, setOCRFormData] = useState(null);
  const [ocrReadDone, setOCRReadDone] = useState(false);
  const [ocrDetails, setOCRDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  
  const [ocrAadhaarFront, setOCRAadhaarFront] = useState(null);
  const [ocrAadhaarBack, setOCRAadhaarBack] = useState(null);
  const [ocrPan, setOCRPan] = useState(null);
  
  const [open, setOpen] = useState(false);
  const [link, setLink] = useState("");
  
  // File upload tracking
  const [uploadedFiles, setUploadedFiles] = useState([]);
  
  const handleCloseConsent = () => setOpen(false);

  // OCR file card types configuration
  const OCRfileCardTypes = [
    {
      id: 'aadhaar_front',
      label: 'Aadhaar Front/Full ',
      image: aadhaarImage,
      disabled: false
    },
    {
      id: 'aadhaar_back',
      label: 'Aadhaar Back',
      image: aadhaarImage,
      disabled: false
    },
    {
      id: 'pan',
      label: 'PAN',
      image: panImage,
      disabled: false
    }
  ];

  // Helper function to check if trigger button should be enabled
  const isTriggerEnabled = () => {
    return ocrAadhaarFront !== null && ocrPan !== null;
  };

    // Function to reset all uploaded files to initial state
  const resetAllFiles = () => {
    setOCRAadhaarFront(null);
    setOCRAadhaarBack(null);
    setOCRPan(null);
    setUploadedFiles([]);
  };

  
    // OCR read function - now calls parent callbacks
    const readOcr = () => {
      const readOCRUrl = `/ocr/read`;
      const data = new FormData();
  
      if (ocrAadhaarFront)
        data.append("aadhaarFront", ocrAadhaarFront);
      if (ocrAadhaarBack)
        data.append("aadhaarBack", ocrAadhaarBack);
      if (ocrPan)
        data.append("pan", ocrPan);
  
      // Set loading state and notify parent that OCR started
      setIsLoading(true);
      if (onOCRStart) {
        onOCRStart();
      }
  
      axiosInstance.post(readOCRUrl, data)
        .then((res => {
          axiosInstance.get(`/ocr/data?id=${res.data.data.id}`)
            .then((resp) => {
              setOCRReadDone(!ocrReadDone);
              setOCRFormData(resp.data.data);
              setIsLoading(false);

          // Reset all uploaded files after successful OCR
            resetAllFiles();
              
              // Send success response to parent
              if (onOCRSuccess) {
                onOCRSuccess(resp.data.data);
              }
            })
            .catch((err) => {
              setIsLoading(false);
              alert("Fail to read OCR details");
              if (onOCRError) {
                onOCRError(err);
              }
            });
          setOCRDetails(res.data.data.id);
        }))
        .catch((err) => {
          setIsLoading(false);
          alert("OCR read Failed!");
          if (onOCRError) {
            onOCRError(err);
          }
        });
    };

  // testing ocr

//   const readOcr = () => {
//   const readOCRUrl = `/ocr/read`;
//   const data = new FormData();

//   if (ocrAadhaarFront) data.append("aadhaarFront", ocrAadhaarFront);
//   if (ocrAadhaarBack) data.append("aadhaarBack", ocrAadhaarBack);
//   if (ocrPan) data.append("pan", ocrPan);

//   setIsLoading(true);
//   if (onOCRStart) {
//     onOCRStart();
//   }

//   // 🔁 Mocked POST response
//   const mockPostResponse = {
//     data: {
//       data: {
//         id: "03d23230-4414-4c20-934e-0a7aa8f5c4f6",
//       },
//     },
//   };

//   // Simulate POST delay
//   setTimeout(() => {
//     const res = mockPostResponse;

//     // Store OCR details from mock
//     setOCRDetails(res.data.data.id);

//     // Use real GET call with the mocked ID
//     axiosInstance
//       .get(`/ocr/data?id=${res.data.data.id}`)
//       .then((resp) => {
//         setOCRReadDone(!ocrReadDone);
//         setOCRFormData(resp.data.data);
//         setIsLoading(false);

//         if (onOCRSuccess) {
//           onOCRSuccess(resp.data.data);
//         }
//       })
//       .catch((err) => {
//         setIsLoading(false);
//         alert("Fail to read OCR details");
//         if (onOCRError) {
//           onOCRError(err);
//         }
//       });
//   }, 10000); // simulate POST delay
// };


  // Preview functions for each file type
  const previewOcrAadhaarFront = (file) => {
    setOCRAadhaarFront(file);
  };

  const previewOcrAadhaarBack = (file) => {
    setOCRAadhaarBack(file);
  };

  const previewOcrPan = (file) => {
    setOCRPan(file);
  };

  // Handle file uploads
  const handleFiles = (file, fileType) => {
    if (!file) return;

    // Remove existing file of same type
    setUploadedFiles(prev => prev.filter(f => f.fileType !== fileType));
    
    // Add new file
    const newFile = {
      fileType,
      fileName: file.name,
      file: file
    };
    setUploadedFiles(prev => [...prev, newFile]);

    // Call appropriate preview function
    switch (fileType) {
      case 'aadhaar_front':
        previewOcrAadhaarFront(file);
        break;
      case 'aadhaar_back':
        previewOcrAadhaarBack(file);
        break;
      case 'pan':
        previewOcrPan(file);
        break;
      default:
        break;
    }
  };

  // Handle file deletion
  const handleDeleteFile = (fileType) => {
    setUploadedFiles(prev => prev.filter(f => f.fileType !== fileType));
    
    // Clear state
    switch (fileType) {
      case 'aadhaar_front':
        setOCRAadhaarFront(null);
        break;
      case 'aadhaar_back':
        setOCRAadhaarBack(null);
        break;
      case 'pan':
        setOCRPan(null);
        break;
      default:
        break;
    }
  };

  // Get uploaded file for a specific type
  const getUploadedFile = (fileType) => {
    switch (fileType) {
      case 'aadhaar_front':
        return ocrAadhaarFront;
      case 'aadhaar_back':
        return ocrAadhaarBack;
      case 'pan':
        return ocrPan;
      default:
        return null;
    }
  };

  return (
    <>
      <Box className='fields-container'>
        <h5 className='form-heading' style={{ marginBottom: '5px' }}>File Uploads</h5>
        <Box sx={{display:'flex', flexWrap:'wrap', justifyContent:'center', alignItems:'center'  }}>
          {OCRfileCardTypes.map((fileCard, index) => (
            <Box key={fileCard?.id} sx = {{marginRight: '30px'}}>      
              <InputFileUpload 
                key={fileCard?.id} 
                image={fileCard.image} 
                label={fileCard.label} 
                id={fileCard.id} 
                handleFiles={handleFiles} 
                disabled={fileCard.disabled}
                uploadedFile={getUploadedFile(fileCard.id)}
                onDelete={() => handleDeleteFile(fileCard.id)}
              />
            </Box>
          ))}
        </Box>

        <div style={{alignSelf: 'center',marginTop: '0em', marginBottom: '0em'}}>
          <button 
            onClick={() => readOcr()} 
            disabled={isLoading || !isTriggerEnabled()}
            style={{
              border:'none',
              borderRadius:'10px',
              width:'10em',
              backgroundColor: (isLoading || !isTriggerEnabled()) ? "#ccc" : "#D22129",
              color:'white',
              fontFamily:'Inter-Medium',
              fontSize:'14px',
              // padding: '10px',
              cursor:(isLoading || !isTriggerEnabled()) ? 'not-allowed' : 'pointer',
              opacity: (isLoading || !isTriggerEnabled()) ? 0.6 : 1
            }}  
            type="button"
          >
            {isLoading ? 'Processing...' : 'Save'}
          </button>

            {/* Optional: Show helper text when button is disabled */}
          {!isTriggerEnabled() && !isLoading && (
            <p style={{ 
              fontSize: '10px', 
              color: '#666', 
              textAlign: 'center', 
              // marginTop: '8px',
              fontStyle: 'italic'
            }}>
              Please upload at least Aadhaar Front/Full and PAN to continue
            </p>
          )}

        </div>
      </Box>

      <OCRLoadingModal isLoading={isLoading} />
    </>
  );
};

export default OCRFileUpload;